// Prefer an Arabic field when the user is browsing in AR, otherwise fall
// back to the canonical English value. Keeps display logic in one place.
export function pickField(obj, key, lang) {
  if (!obj) return "";
  if (lang === "ar") {
    const ar = obj[`${key}_ar`];
    if (ar && String(ar).trim()) return ar;
  }
  return obj[key] || "";
}
